(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(2364);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(7484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@bukuwarung/sachet/index.js
var sachet = __webpack_require__(3030);
// EXTERNAL MODULE: ./node_modules/@bukuwarung/sachet/utils/index.js
var utils = __webpack_require__(9994);
// EXTERNAL MODULE: ./node_modules/animated-number-react/build/index.js
var build = __webpack_require__(8912);
var build_default = /*#__PURE__*/__webpack_require__.n(build);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/isBetween.js
var isBetween = __webpack_require__(6607);
var isBetween_default = /*#__PURE__*/__webpack_require__.n(isBetween);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./components/Global/GlobalProvider.tsx
var GlobalProvider = __webpack_require__(789);
// EXTERNAL MODULE: ./constants/index.ts
var constants = __webpack_require__(1407);
// EXTERNAL MODULE: ./lib/axios.ts + 41 modules
var axios = __webpack_require__(8598);
// EXTERNAL MODULE: ./locale/index.ts + 11 modules
var locale = __webpack_require__(1590);
// EXTERNAL MODULE: ./utils/api/index.ts
var api = __webpack_require__(5830);
;// CONCATENATED MODULE: ./data/accounting/index.ts






var GetAnalyticsSummary = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var params, onError, onSuccess;
        return (0,tslib_es6.__generator)(this, function(_state) {
            params = param.params, onError = param.onError, onSuccess = param.onSuccess;
            return [
                2,
                axios/* default.get */.Z.get("".concat(constants/* INVOICE_API_BASE_URL */.Gl, "/analytics/summary"), {
                    params: params
                }).then(function(res) {
                    if (res.status === 200 && res.data.result) {
                        onSuccess(res.data.data);
                        return;
                    }
                    onError(locale/* default.id.common.request_error */.Z.id.common.request_error);
                }).catch(function(err) {
                    onError((0,api/* getErrorMessage */.e)(false, err).error.message);
                })
            ];
        });
    });
    return function GetAnalyticsSummary(_) {
        return _ref.apply(this, arguments);
    };
}();
var GetAnalyticsProduct = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var params, onError, onSuccess;
        return (0,tslib_es6.__generator)(this, function(_state) {
            params = param.params, onError = param.onError, onSuccess = param.onSuccess;
            return [
                2,
                axios/* default.get */.Z.get("".concat(constants/* INVOICE_API_BASE_URL */.Gl, "/analytics/product"), {
                    params: params
                }).then(function(res) {
                    if (res.status === 200 && res.data.result) {
                        onSuccess(res.data.data);
                        return;
                    }
                    onError(locale/* default.id.common.request_error */.Z.id.common.request_error);
                }).catch(function(err) {
                    onError((0,api/* getErrorMessage */.e)(false, err).error.message);
                })
            ];
        });
    });
    return function GetAnalyticsProduct(_) {
        return _ref.apply(this, arguments);
    };
}();
var GetAnalyticsCustomer = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var params, onError, onSuccess;
        return (0,tslib_es6.__generator)(this, function(_state) {
            params = param.params, onError = param.onError, onSuccess = param.onSuccess;
            return [
                2,
                axios/* default.get */.Z.get("".concat(constants/* INVOICE_API_BASE_URL */.Gl, "/analytics/customer"), {
                    params: params
                }).then(function(res) {
                    if (res.status === 200 && res.data.result) {
                        onSuccess(res.data.data);
                        return;
                    }
                    onError(locale/* default.id.common.request_error */.Z.id.common.request_error);
                }).catch(function(err) {
                    onError((0,api/* getErrorMessage */.e)(false, err).error.message);
                })
            ];
        });
    });
    return function GetAnalyticsCustomer(_) {
        return _ref.apply(this, arguments);
    };
}();
var GetAnalyticsVendor = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var params, onError, onSuccess;
        return (0,tslib_es6.__generator)(this, function(_state) {
            params = param.params, onError = param.onError, onSuccess = param.onSuccess;
            return [
                2,
                axios/* default.get */.Z.get("".concat(constants/* INVOICE_API_BASE_URL */.Gl, "/analytics/vendor"), {
                    params: params
                }).then(function(res) {
                    if (res.status === 200 && res.data.result) {
                        onSuccess(res.data.data);
                        return;
                    }
                    onError(locale/* default.id.common.request_error */.Z.id.common.request_error);
                }).catch(function(err) {
                    onError((0,api/* getErrorMessage */.e)(false, err).error.message);
                })
            ];
        });
    });
    return function GetAnalyticsVendor(_) {
        return _ref.apply(this, arguments);
    };
}();
var GetAnalyticsSalesGraph = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var params, onError, onSuccess;
        return (0,tslib_es6.__generator)(this, function(_state) {
            params = param.params, onError = param.onError, onSuccess = param.onSuccess;
            return [
                2,
                axios/* default.get */.Z.get("".concat(constants/* INVOICE_API_BASE_URL */.Gl, "/analytics/graph/sales"), {
                    params: params
                }).then(function(res) {
                    if (res.status === 200 && res.data.result) {
                        onSuccess(res.data.data);
                        return;
                    }
                    onError(locale/* default.id.common.request_error */.Z.id.common.request_error);
                }).catch(function(err) {
                    onError((0,api/* getErrorMessage */.e)(false, err).error.message);
                })
            ];
        });
    });
    return function GetAnalyticsSalesGraph(_) {
        return _ref.apply(this, arguments);
    };
}();
var GetAnalyticsPaymentsGraph = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var params, onError, onSuccess;
        return (0,tslib_es6.__generator)(this, function(_state) {
            params = param.params, onError = param.onError, onSuccess = param.onSuccess;
            return [
                2,
                axios/* default.get */.Z.get("".concat(constants/* INVOICE_API_BASE_URL */.Gl, "/analytics/graph/payments"), {
                    params: params
                }).then(function(res) {
                    if (res.status === 200 && res.data.result) {
                        onSuccess(res.data.data);
                        return;
                    }
                    onError(locale/* default.id.common.request_error */.Z.id.common.request_error);
                }).catch(function(err) {
                    onError((0,api/* getErrorMessage */.e)(false, err).error.message);
                })
            ];
        });
    });
    return function GetAnalyticsPaymentsGraph(_) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./utils/common.ts + 1 modules
var common = __webpack_require__(9807);
;// CONCATENATED MODULE: ./components/Analytics/AnalyticsCustomer.tsx










var AnalyticsCustomer = function(param) {
    var _type = param.type, type = _type === void 0 ? "summary" : _type, _pageSize = param.pageSize, pageSize = _pageSize === void 0 ? 10 : _pageSize, startDateTime = param.startDateTime, endDateTime = param.endDateTime, _title = param.title, title = _title === void 0 ? true : _title, _className = param.className, className = _className === void 0 ? "" : _className, _onClickMore = param.onClickMore, onClickMore = _onClickMore === void 0 ? function() {
        return false;
    } : _onClickMore;
    var snackbar = (0,GlobalProvider/* useGlobal */.Og)().snackbar;
    var ref = (0,react.useState)(true), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(function() {
        return {
            pageNo: 0,
            pageSize: pageSize,
            startDateTime: startDateTime,
            endDateTime: endDateTime
        };
    }), filter = ref1[0], setFilter = ref1[1];
    var ref2 = (0,react.useState)({
        customerList: [],
        pagination: {
            pageNo: 0,
            pageSize: pageSize,
            totalElements: 0,
            totalPages: 0
        }
    }), data = ref2[0], setData = ref2[1];
    (0,react.useEffect)(function() {
        load(0);
    }, [
        startDateTime,
        endDateTime
    ]);
    var load = function(pageNo) {
        setLoading(true);
        var _filter = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filter), {
            pageNo: pageNo,
            startDateTime: startDateTime,
            endDateTime: endDateTime
        });
        setFilter(_filter);
        GetAnalyticsCustomer({
            params: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _filter), {
                startDateTime: startDateTime,
                endDateTime: endDateTime
            }),
            onSuccess: function(res) {
                setData(res);
            },
            onError: function(message) {
                snackbar.snackbarHandle({
                    message: message,
                    value: true,
                    style: "error"
                });
            }
        }).then(function() {
            (0,common/* delayedCallback */.sf)(function() {
                setLoading(false);
            }, 500);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col ".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-grow overflow-auto",
                children: [
                    title && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.Typography, {
                                variant: "h3",
                                fontWeight: "medium",
                                size: "lg",
                                className: "mb-3 flex items-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "mr-1",
                                    children: "Pembeli"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.LineSkeleton, {
                                    count: 1,
                                    size: "3xl",
                                    className: "w-32"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.Typography, {
                                    size: "2xl",
                                    fontWeight: "bold",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((build_default()), {
                                        duration: 200,
                                        value: data.pagination.totalElements,
                                        formatValue: function(value) {
                                            return (0,utils.formatNumberToCurrencyString)(Math.round(value));
                                        }
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.Table, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.TableBody, {
                            children: renderContent(loading, type, data)
                        })
                    })
                ]
            }),
            type === "detail" ? data.pagination.totalElements > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-center border-t border-neutrals-200 px-4 pb-4 pt-4 sm:justify-between sm:px-5 sm:pt-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "mr-1 hidden text-sm sm:block",
                        children: [
                            data.customerList.length + data.pagination.pageSize * data.pagination.pageNo,
                            " dari",
                            " ",
                            data.pagination.totalElements,
                            " pembeli"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.Pagination, {
                        total: data.pagination.totalElements,
                        itemPerPage: filter.pageSize,
                        current: filter.pageNo + 1,
                        onSelect: function(value) {
                            load(value - 1);
                        }
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: data.pagination.totalElements > pageSize && !loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    role: "button",
                    className: "mt-4 flex items-center justify-end text-center text-sm text-primary no-underline hover:underline sm:mt-5",
                    onClick: onClickMore,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "mr-1",
                            children: "Lihat lebih banyak"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.Icon, {
                            name: "chevron-right"
                        })
                    ]
                })
            })
        ]
    });
};
var renderContent = function(loading, type, data) {
    if (loading) {
        return Array(3).fill(1).map(function(_, key) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(sachet.TableRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.TableColumn, {
                        paddingLeft: type === "detail" ? "lg" : "none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.LineSkeleton, {
                            count: 1,
                            size: "lg",
                            className: "w-32"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.TableColumn, {
                        paddingRight: type === "detail" ? "lg" : "none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.LineSkeleton, {
                            count: 1,
                            size: "lg",
                            className: "w-32"
                        })
                    })
                ]
            }, key);
        });
    }
    if (data.customerList.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.TableRow, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.TableColumn, {
                paddingLeft: "none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.Typography, {
                    children: "Tidak ada data."
                })
            })
        });
    }
    return data.customerList.map(function(item, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(sachet.TableRow, {
            border: !(index === data.customerList.length - 1 && type === "detail"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.TableColumn, {
                    paddingLeft: type === "detail" ? "lg" : "none",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-normal",
                        children: item.name
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.TableColumn, {
                    paddingRight: type === "detail" ? "lg" : "none",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-right font-normal",
                        children: [
                            "Rp",
                            (0,utils.formatNumberToCurrencyString)(Math.round(item.totalCost))
                        ]
                    })
                })
            ]
        }, item.id);
    });
};

;// CONCATENATED MODULE: ./components/Analytics/AnalyticsProduct.tsx










var AnalyticsProduct = function(param) {
    var _type = param.type, type = _type === void 0 ? "summary" : _type, _pageSize = param.pageSize, pageSize = _pageSize === void 0 ? 10 : _pageSize, startDateTime = param.startDateTime, endDateTime = param.endDateTime, _title = param.title, title = _title === void 0 ? true : _title, _className = param.className, className = _className === void 0 ? "" : _className, _onClickMore = param.onClickMore, onClickMore = _onClickMore === void 0 ? function() {
        return false;
    } : _onClickMore;
    var snackbar = (0,GlobalProvider/* useGlobal */.Og)().snackbar;
    var ref = (0,react.useState)(true), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(function() {
        return {
            pageNo: 0,
            pageSize: pageSize,
            startDateTime: startDateTime,
            endDateTime: endDateTime
        };
    }), filter = ref1[0], setFilter = ref1[1];
    var ref2 = (0,react.useState)({
        productList: [],
        pagination: {
            pageNo: 0,
            pageSize: pageSize,
            totalElements: 0,
            totalPages: 0
        }
    }), data = ref2[0], setData = ref2[1];
    (0,react.useEffect)(function() {
        load(0);
    }, [
        startDateTime,
        endDateTime
    ]);
    var load = function(pageNo) {
        setLoading(true);
        var _filter = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filter), {
            pageNo: pageNo,
            startDateTime: startDateTime,
            endDateTime: endDateTime
        });
        setFilter(_filter);
        GetAnalyticsProduct({
            params: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _filter), {
                startDateTime: startDateTime,
                endDateTime: endDateTime
            }),
            onSuccess: function(res) {
                setData(res);
            },
            onError: function(message) {
                snackbar.snackbarHandle({
                    message: message,
                    value: true,
                    style: "error"
                });
            }
        }).then(function() {
            (0,common/* delayedCallback */.sf)(function() {
                setLoading(false);
            }, 500);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col ".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-grow overflow-auto",
                children: [
                    title && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.Typography, {
                                variant: "h3",
                                fontWeight: "medium",
                                size: "lg",
                                className: "mb-3 flex items-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "mr-1",
                                    children: "Produk Terjual"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.LineSkeleton, {
                                    count: 1,
                                    size: "3xl",
                                    className: "w-32"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((build_default()), {
                                    duration: 200,
                                    value: data.pagination.totalElements,
                                    formatValue: function(value) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.Typography, {
                                            size: "2xl",
                                            fontWeight: "bold",
                                            children: (0,utils.formatNumberToCurrencyString)(Math.round(value))
                                        });
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.Table, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.TableBody, {
                            children: AnalyticsProduct_renderContent(loading, type, data)
                        })
                    })
                ]
            }),
            type === "detail" ? data.pagination.totalElements > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-center border-t border-neutrals-200 px-4 pb-4 pt-4 sm:justify-between sm:px-5 sm:pt-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "mr-1 hidden text-sm sm:block",
                        children: [
                            data.productList.length + data.pagination.pageSize * data.pagination.pageNo,
                            " dari",
                            " ",
                            data.pagination.totalElements,
                            " produk"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.Pagination, {
                        total: data.pagination.totalElements,
                        itemPerPage: filter.pageSize,
                        current: filter.pageNo + 1,
                        onSelect: function(value) {
                            load(value - 1);
                        }
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: data.pagination.totalElements > pageSize && !loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    role: "button",
                    className: "mt-4 flex items-center justify-end text-center text-sm text-primary no-underline hover:underline sm:mt-5",
                    onClick: onClickMore,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "mr-1",
                            children: "Lihat lebih banyak"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.Icon, {
                            name: "chevron-right"
                        })
                    ]
                })
            })
        ]
    });
};
var AnalyticsProduct_renderContent = function(loading, type, data) {
    if (loading) {
        return Array(3).fill(1).map(function(_, key) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(sachet.TableRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.TableColumn, {
                        paddingLeft: type === "detail" ? "lg" : "none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.LineSkeleton, {
                            count: 1,
                            size: "lg",
                            className: "w-32"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.TableColumn, {
                        paddingRight: type === "detail" ? "lg" : "none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.LineSkeleton, {
                            count: 1,
                            size: "lg",
                            className: "w-32"
                        })
                    })
                ]
            }, key);
        });
    }
    if (data.productList.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.TableRow, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.TableColumn, {
                paddingLeft: "none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.Typography, {
                    children: "Tidak ada data."
                })
            })
        });
    }
    return data.productList.map(function(item, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(sachet.TableRow, {
            border: !(index === data.productList.length - 1 && type === "detail"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.TableColumn, {
                    paddingLeft: type === "detail" ? "lg" : "none",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-normal",
                        children: item.name
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.TableColumn, {
                    paddingRight: type === "detail" ? "lg" : "none",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-right font-normal",
                        children: (0,utils.formatNumberToCurrencyString)(item.soldCount)
                    })
                })
            ]
        }, item.id);
    });
};

// EXTERNAL MODULE: ./components/Meta.tsx
var Meta = __webpack_require__(3149);
// EXTERNAL MODULE: ./types/invoice/index.ts
var invoice = __webpack_require__(5043);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
;// CONCATENATED MODULE: ./components/LineChart.tsx




var MIN_HEIGHT = 380;
var MIN_WIDTH = 300;
var HEIGHT_RATIO = 0.33602941176471;
var Y_TICKS_COUNT = 5;
var FONT_SIZE = 14;
var X_TICKS_WRAPPER_HEIGHT = 28;
var SPACE = 40;
var POINT_SIZE = 6;
var ANIMATION_SPEED = 1;
var MIN_UPPER_BOUND = 1000;
var MIN_LOWER_BOUND = 0;
var TOOLTIP_SPACE = 20;
var TOOLTIP_WIDTH = 256;
var COLORS_SCHEME = [
    sachet.COLORS.MAIN.PRIMARY.DEFAULT,
    sachet.COLORS.MAIN.SECONDARY.DEFAULT,
    sachet.COLORS.SEMANTIC.AMBER.DEFAULT,
    sachet.COLORS.SEMANTIC.GREEN.DEFAULT,
    sachet.COLORS.SEMANTIC.BLUE.DEFAULT,
    sachet.COLORS.SEMANTIC.RED.DEFAULT
];
var LineChart = function(param) {
    var _data = param.data, data = _data === void 0 ? {
        labels: [],
        sets: []
    } : _data, _minWidth = param.minWidth, minWidth = _minWidth === void 0 ? MIN_WIDTH : _minWidth, _minHeight = param.minHeight, minHeight = _minHeight === void 0 ? MIN_HEIGHT : _minHeight, _heightRatio = param.heightRatio, heightRatio = _heightRatio === void 0 ? HEIGHT_RATIO : _heightRatio, _yTicksCount = param.yTicksCount, yTicksCount = _yTicksCount === void 0 ? Y_TICKS_COUNT : _yTicksCount, _fontSize = param.fontSize, fontSize = _fontSize === void 0 ? FONT_SIZE : _fontSize, _xTicksWrapperHeight = param.xTicksWrapperHeight, xTicksWrapperHeight = _xTicksWrapperHeight === void 0 ? X_TICKS_WRAPPER_HEIGHT : _xTicksWrapperHeight, _space = param.space, space = _space === void 0 ? SPACE : _space, _pointSize = param.pointSize, pointSize = _pointSize === void 0 ? POINT_SIZE : _pointSize, _animationSpeed = param.animationSpeed, animationSpeed = _animationSpeed === void 0 ? ANIMATION_SPEED : _animationSpeed, _minUpperBound = param.minUpperBound, minUpperBound = _minUpperBound === void 0 ? MIN_UPPER_BOUND : _minUpperBound, _minLowerBound = param.minLowerBound, minLowerBound = _minLowerBound === void 0 ? MIN_LOWER_BOUND : _minLowerBound, _tooltipSpace = param.tooltipSpace, tooltipSpace = _tooltipSpace === void 0 ? TOOLTIP_SPACE : _tooltipSpace, _tooltipWidth = param.tooltipWidth, tooltipWidth = _tooltipWidth === void 0 ? TOOLTIP_WIDTH : _tooltipWidth, _colors = param.colors, colors = _colors === void 0 ? COLORS_SCHEME : _colors, _formatYTicks = param.formatYTicks, formatYTicks = _formatYTicks === void 0 ? function(value) {
        return String(value);
    } : _formatYTicks, _formatXTicks = param.formatXTicks, formatXTicks = _formatXTicks === void 0 ? function(value) {
        return value;
    } : _formatXTicks, _formatLegends = param.formatLegends, formatLegends = _formatLegends === void 0 ? function(value, label, color) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center p-2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mr-2 h-3.5 w-3.5 rounded-full",
                    style: {
                        backgroundColor: color
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mr-2",
                    children: [
                        label,
                        " :"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "font-bold",
                    children: value
                })
            ]
        });
    } : _formatLegends;
    var ref;
    var mainWrapper = (0,react.useRef)(null);
    var yWrapper = (0,react.useRef)(null);
    var xWrapper = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(function() {
        return data.sets.map(function(item) {
            var value = item.values[0] | 0;
            return {
                value: value,
                label: formatYTicks(value, value),
                y: 0
            };
        });
    }), yTicks = ref1[0], setYTicks = ref1[1];
    var ref2 = (0,react.useState)(function() {
        return data.sets.map(function(item, index) {
            return {
                name: formatXTicks(item.xTickName, index),
                x: 0
            };
        });
    }), xTicks = ref2[0], setXTicks = ref2[1];
    var frameWidth = Math.max(((ref = mainWrapper.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect().width) || 0, minWidth);
    var frameHeight = Math.max(frameWidth * heightRatio, minHeight);
    var yWrapperProps = (0,react.useMemo)(function() {
        var ref;
        var ref1 = ((ref = yWrapper.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect()) || {
            width: 0,
            height: 0
        }, width = ref1.width, height = ref1.height;
        return {
            x: width,
            width: width,
            height: height
        };
    }, [
        yTicks,
        yWrapper,
        frameWidth,
        frameHeight
    ]);
    var xTickElementWidth = (0,react.useMemo)(function() {
        var ref;
        var elements = ((ref = xWrapper.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll("text")) || [];
        var width = 0;
        elements.forEach(function(element) {
            var elementWidth = element.getBoundingClientRect().width;
            if (elementWidth > width) {
                width = elementWidth;
            }
        });
        return width;
    }, [
        xTicks,
        xWrapper,
        frameWidth,
        frameHeight
    ]);
    var visualWidth = frameWidth - yWrapperProps.width - space;
    var visualHeight = frameHeight - xTicksWrapperHeight - space;
    var lineWidth = visualWidth - xTickElementWidth / 2;
    var lineHeight = visualHeight + fontSize;
    var ref3 = (0,react.useState)([]), lineMark = ref3[0], setLineMark = ref3[1];
    var ref4 = (0,react.useState)(false), showLineMark = ref4[0], setShowLineMark = ref4[1];
    var tooltipRef = (0,react.useRef)(null);
    var getRange = function() {
        var sortedData = (0,_to_consumable_array/* default */.Z)(data.sets).map(function(item) {
            return item.values;
        }).reduce(function(a, b) {
            return a.concat(b);
        }, []).sort(function(a, b) {
            return a - b;
        });
        var upperBound = Math.max(sortedData[sortedData.length - 1], minUpperBound);
        var lowerBound = sortedData[0] === upperBound ? minLowerBound : sortedData[0];
        var range = upperBound - lowerBound;
        return {
            upperBound: upperBound,
            lowerBound: lowerBound,
            range: range
        };
    };
    var getLabel = function(index) {
        return data.labels[index] || "data ".concat(index + 1);
    };
    var getColor = function(index) {
        return colors[index] || sachet.COLORS.MAIN.NEUTRALS.DEFAULT;
    };
    var points = (0,react.useMemo)(function() {
        var ref = getRange(), lowerBound = ref.lowerBound, range = ref.range;
        var interval = data.sets.length - 1 === 0 ? 0 : lineWidth / (data.sets.length - 1);
        var yCoordinateInterval = visualHeight / range;
        return data.sets.map(function(item, index) {
            var x = interval * index;
            return item.values.map(function(value, index) {
                var y = visualHeight - (value - lowerBound) * yCoordinateInterval + fontSize;
                return {
                    x: x,
                    y: y,
                    value: value,
                    label: getLabel(index),
                    color: getColor(index),
                    xTickName: item.xTickName
                };
            });
        });
    }, [
        yTicks,
        xTicks,
        lineWidth,
        visualHeight
    ]);
    (0,react.useEffect)(function() {
        calculateYTicks();
        calculateXTicks();
    }, [
        visualHeight,
        lineWidth
    ]);
    var calculateYTicks = function() {
        var ref = getRange(), lowerBound = ref.lowerBound, range = ref.range;
        var denominators = yTicksCount - 1;
        var interval = range / denominators;
        var yCoordinateInterval = visualHeight / denominators;
        var ticks = [];
        for(var i = 0; i < yTicksCount; i++){
            var tick = interval * i + lowerBound;
            var yCoordinate = visualHeight - yCoordinateInterval * i;
            ticks.push({
                value: tick,
                label: formatYTicks(tick, interval),
                y: yCoordinate
            });
        }
        setYTicks(ticks);
    };
    var calculateXTicks = function() {
        var xCoordinateInterval = data.sets.length - 1 === 0 ? 0 : lineWidth / (data.sets.length - 1);
        var ticks = [];
        for(var i = 0; i < data.sets.length; i++){
            var xCoordinate = xCoordinateInterval * i;
            ticks.push({
                name: formatXTicks(data.sets[i].xTickName, i),
                x: xCoordinate
            });
        }
        setXTicks(ticks);
    };
    var drawLine = function() {
        return points.reduce(function(acc, item, index) {
            if (index === 0) {
                return item.map(function(point) {
                    return "M ".concat(point.x, " ").concat(point.y);
                });
            }
            return item.map(function(point, i) {
                var prevPoint = points[index - 1][i];
                var x1 = prevPoint.x + (point.x - prevPoint.x) / 2;
                var y1 = prevPoint.y;
                var x2 = point.x - (point.x - prevPoint.x) / 2;
                var y2 = point.y;
                return "".concat(acc[i], " C ").concat(x1, " ").concat(y1, ", ").concat(x2, " ").concat(y2, ", ").concat(point.x, " ").concat(point.y);
            });
        }, []);
    };
    var getTooltipPosition = function() {
        var ref, ref1;
        var x = ((ref = lineMark[0]) === null || ref === void 0 ? void 0 : ref.x) || 0;
        var elementWidth = ((ref1 = tooltipRef.current) === null || ref1 === void 0 ? void 0 : ref1.clientWidth) || tooltipWidth;
        var tooltipRightOffset = elementWidth + x;
        if (tooltipRightOffset > visualWidth) {
            return "translate(".concat(x - elementWidth - tooltipSpace, ", ", 0, ")");
        }
        return "translate(".concat(x + tooltipSpace, ", ", 0, ")");
    };
    var renderYTicks = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            ref: yWrapper,
            transform: "translate(".concat(yWrapperProps.x, ", 0)"),
            children: yTicks.map(function(item, key) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("text", {
                    fontFamily: "Inter, sans-serif",
                    y: item.y + fontSize,
                    textAnchor: "end",
                    dominantBaseline: "auto",
                    fontSize: fontSize,
                    fontWeight: "500",
                    fill: sachet.COLORS.MAIN.NEUTRALS[600],
                    className: "apexcharts-text apexcharts-yaxis-label ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tspan", {
                            children: item.label
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                            children: item.label
                        })
                    ]
                }, "yTicks_".concat(item.value, "_").concat(key));
            })
        });
    };
    var renderHorizontalLines = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            transform: "translate(0, 0)",
            children: Array(yTicks.length - 1).fill(1).map(function(_, key) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                    x1: "0",
                    x2: lineWidth,
                    y1: visualHeight - yTicks[key].y + fontSize,
                    y2: visualHeight - yTicks[key].y + fontSize,
                    stroke: sachet.COLORS.MAIN.NEUTRALS[100],
                    strokeDasharray: "0",
                    strokeWidth: "1",
                    strokeLinecap: "butt"
                }, "line_".concat(yTicks[key].y, "_").concat(key));
            })
        });
    };
    var renderXticks = function() {
        var getOpactity = function() {
            if (xTickElementWidth * xTicks.length > lineWidth) {
                return 0;
            }
            return 1;
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            transform: "translate(0, ".concat(lineHeight, ")"),
            opacity: getOpactity(),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    transform: "translate(0, ".concat(fontSize, ")"),
                    ref: xWrapper,
                    children: xTicks.map(function(item, key) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("text", {
                            fontFamily: "Inter, sans-serif",
                            x: item.x,
                            y: fontSize,
                            textAnchor: "middle",
                            dominantBaseline: "auto",
                            fontSize: fontSize,
                            fontWeight: "500",
                            fill: sachet.COLORS.MAIN.NEUTRALS[600],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("tspan", {
                                    id: "SvgjsTspan1480",
                                    children: item.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                                    children: item.name
                                })
                            ]
                        }, "xTicks_".concat(item.x, "_").concat(key));
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                    x1: "0",
                    y1: "0",
                    x2: lineWidth,
                    y2: "0",
                    stroke: sachet.COLORS.MAIN.NEUTRALS[200],
                    strokeDasharray: "0",
                    strokeWidth: "1",
                    strokeLinecap: "butt"
                })
            ]
        });
    };
    var renderBlocks = function() {
        var poinstLastIndex = points.length - 1;
        var width = poinstLastIndex === 0 ? visualWidth : visualWidth / poinstLastIndex;
        var getX = function(x) {
            return x - width / 2;
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "cut-off-left",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "0",
                            y: "0",
                            width: width,
                            height: lineHeight
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    children: points.map(function(item, key) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            clipPath: key === 0 ? 'url("#cut-off-left")' : undefined,
                            width: width,
                            height: lineHeight,
                            x: getX(item[0].x),
                            y: 0,
                            opacity: 0,
                            onMouseEnter: function() {
                                setLineMark(item);
                                setShowLineMark(true);
                            },
                            onMouseLeave: function() {
                                setShowLineMark(false);
                            },
                            onTouchEnd: function() {
                                setLineMark(item);
                                setShowLineMark(true);
                            }
                        }, "block-hover_".concat(key));
                    })
                })
            ]
        });
    };
    var renderLineMark = function() {
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            transform: "translate(".concat(((ref = lineMark[0]) === null || ref === void 0 ? void 0 : ref.x) || 0, ", 0)"),
            className: "pointer-events-none",
            opacity: showLineMark ? 1 : 0,
            style: {
                transition: "all 0.1s ease-out"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: "0",
                y1: fontSize,
                x2: "0",
                y2: lineHeight,
                stroke: sachet.COLORS.MAIN.NEUTRALS[300],
                strokeDasharray: "10",
                strokeLinecap: "butt",
                fill: "#b1b9c4",
                filter: "none",
                fillOpacity: "0.9",
                strokeWidth: "1"
            })
        });
    };
    var renderPaths = function() {
        var paths = drawLine();
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            transform: "translate(0, 0)",
            className: "pointer-events-none",
            children: paths.map(function(item, key) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    children: renderPath(item, getColor(key))
                }, "path_".concat(key));
            })
        });
    };
    var renderPath = function(path, color) {
        var pathRef = (0,react.useRef)(null);
        var pathLength = (0,react.useMemo)(function() {
            var ref;
            return (((ref = pathRef.current) === null || ref === void 0 ? void 0 : ref.getTotalLength()) || 0) * 100;
        }, [
            pathRef.current
        ]);
        var speed = animationSpeed * (pathLength / 2000);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "".concat(path, " L ").concat(lineWidth, ", ").concat(lineHeight, " L 0, ").concat(lineHeight, " Z"),
                    fill: color,
                    strokeWidth: 0,
                    fillOpacity: 0,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "fill-opacity",
                        values: "0;0.1",
                        dur: animationSpeed + "s",
                        fill: "freeze",
                        begin: "0s"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    ref: pathRef,
                    d: path,
                    fill: "none",
                    stroke: color,
                    strokeWidth: "4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeDasharray: pathLength > 0 ? pathLength : undefined,
                    strokeDashoffset: pathLength > 0 ? pathLength : undefined,
                    strokeOpacity: "1",
                    children: pathLength > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "stroke-dashoffset",
                        values: "".concat(pathLength, ";0"),
                        dur: speed + "s",
                        fill: "freeze",
                        begin: "0s"
                    })
                })
            ]
        });
    };
    var renderPoints = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            transform: "translate(0, 0)",
            className: "pointer-events-none",
            children: points.map(function(item) {
                return item.map(function(point, key) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("circle", {
                        cx: point.x,
                        cy: point.y,
                        r: ((ref = lineMark[0]) === null || ref === void 0 ? void 0 : ref.x) === point.x ? pointSize * 1.3 : pointSize,
                        "data-t": "line mark = ".concat(lineMark, ", pointX = ").concat(point.x),
                        fill: getColor(key),
                        stroke: sachet.COLORS.MAIN.NEUTRALS.light,
                        strokeWidth: "2",
                        style: {
                            cursor: "pointer",
                            transition: "all ease-out 0.2s"
                        }
                    }, "points_".concat(point.x, "_").concat(key));
                });
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: mainWrapper,
                className: "w-full",
                style: {
                    minHeight: minHeight
                },
                "data-testid": "line-chart",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    width: frameWidth,
                    height: frameHeight,
                    children: [
                        renderYTicks(),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            className: "cursor-crosshair",
                            transform: "translate(".concat(yWrapperProps.width + space, ", 0)"),
                            children: [
                                renderHorizontalLines(),
                                renderXticks(),
                                renderBlocks(),
                                renderLineMark(),
                                renderPaths(),
                                renderPoints(),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("foreignObject", {
                                    width: 0,
                                    height: 0,
                                    className: "pointer-events-none overflow-visible",
                                    transform: getTooltipPosition(),
                                    opacity: showLineMark ? 1 : 0,
                                    style: {
                                        transition: "all 0.1s ease-out"
                                    },
                                    children: lineMark.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        ref: tooltipRef,
                                        className: "relative z-10 overflow-hidden rounded-md bg-white text-sm text-neutrals-500 shadow-md",
                                        style: {
                                            width: tooltipWidth
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "border-b border-neutrals-200 bg-neutrals-100 p-2",
                                                children: lineMark[0].xTickName
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "p-2",
                                                children: lineMark.map(function(item, key) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                        children: formatLegends(formatYTicks(item.value, item.value), item.label, item.color)
                                                    }, "tooltip_item_".concat(key));
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            points.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex w-full items-center justify-center",
                children: points[0].map(function(item, key) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center p-2 text-sm",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mr-2 h-3.5 w-3.5 rounded-full",
                                    style: {
                                        backgroundColor: item.color
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: item.label
                                })
                            ]
                        })
                    }, "legends_item_".concat(key));
                })
            })
        ]
    });
};
var LineChartLoader = function(param) {
    var _heightRatio = param.heightRatio, heightRatio = _heightRatio === void 0 ? HEIGHT_RATIO : _heightRatio, _animationSpeed = param.animationSpeed, animationSpeed = _animationSpeed === void 0 ? 1.8 : _animationSpeed;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative w-full",
        style: {
            padding: "0 0 ".concat(heightRatio * 100, "%")
        },
        "data-testid": "line-chart-loader",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            className: "absolute left-0 top-0 h-full w-full",
            viewBox: "0 0 100 100",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            stroke: sachet.COLORS.MAIN.NEUTRALS[200],
                            id: "baseLine",
                            strokeWidth: "1",
                            fill: "none",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            d: "M0,60 L20,60 L20,60 L40,30 L55,70 L70,30 L80,60 L100,60"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            stroke: sachet.COLORS.MAIN.PRIMARY.DEFAULT,
                            strokeWidth: "1",
                            fill: "none",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                                attributeName: "d",
                                values: "M0,60 L0,60 L0,60 L0,60 L0,60 L0,60 L0,60 L0,60;M0,60 L20,60 L20,60 L20,60 L20,60 L20,60 L20,60 L20,60; M0,60 L20,60 L20,60 L40,30 L40,30 L40,30 L40,30 L40,30; M0,60 L20,60 L20,60 L40,30 L55,70 L55,70 L55,70 L55,70; M0,60 L20,60 L20,60 L40,30 L55,70 L70,30 L70,30 L70,30; M0,60 L20,60 L20,60 L40,30 L55,70 L70,30 L80,60 L80,60; M0,60 L20,60 L20,60 L40,30 L55,70 L70,30 L80,60 L100,60",
                                dur: animationSpeed + "s",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    r: "2",
                    fill: sachet.COLORS.MAIN.PRIMARY.DEFAULT,
                    stroke: sachet.COLORS.MAIN.NEUTRALS.light,
                    strokeWidth: "1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("animateMotion", {
                        dur: animationSpeed + "s",
                        repeatCount: "indefinite",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("mpath", {
                            href: "#baseLine",
                            xlinkHref: "#baseLine"
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/Analytics/AnalyticsDrawer.tsx


var AnalyticsDrawer = function(param) {
    var _show = param.show, show = _show === void 0 ? false : _show, children = param.children, title = param.title, _onDrawerClose = param.onDrawerClose, onDrawerClose = _onDrawerClose === void 0 ? function() {
        return false;
    } : _onDrawerClose;
    if (!show) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-testid": "analytics-drawer",
        className: "absolute bottom-0 right-0 z-10 flex h-full w-[600px] max-w-full flex-col overflow-hidden bg-neutrals-light drop-shadow-md",
        tabIndex: -1,
        "aria-labelledby": "drawer-label",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "drawer-label",
                className: "flex h-[60px] flex-row items-center justify-between border-b border-neutrals-200 px-4 py-4 sm:px-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-1 font-semibold",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "ml-5 cursor-pointer",
                        "data-testid": "analytics-drawer-close-button",
                        onClick: function() {
                            return onDrawerClose();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.Icon, {
                            name: "x-outline",
                            size: "xl"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-grow overflow-hidden",
                children: children
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Analytics/AnalyticsVendor.tsx










var AnalyticsVendor = function(param) {
    var _type = param.type, type = _type === void 0 ? "summary" : _type, _pageSize = param.pageSize, pageSize = _pageSize === void 0 ? 10 : _pageSize, startDateTime = param.startDateTime, endDateTime = param.endDateTime, _title = param.title, title = _title === void 0 ? true : _title, _className = param.className, className = _className === void 0 ? "" : _className, _onClickMore = param.onClickMore, onClickMore = _onClickMore === void 0 ? function() {
        return false;
    } : _onClickMore;
    var snackbar = (0,GlobalProvider/* useGlobal */.Og)().snackbar;
    var ref = (0,react.useState)(true), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(function() {
        return {
            pageNo: 0,
            pageSize: pageSize,
            startDateTime: startDateTime,
            endDateTime: endDateTime
        };
    }), filter = ref1[0], setFilter = ref1[1];
    var ref2 = (0,react.useState)({
        vendorList: [],
        pagination: {
            pageNo: 0,
            pageSize: pageSize,
            totalElements: 0,
            totalPages: 0
        }
    }), data = ref2[0], setData = ref2[1];
    (0,react.useEffect)(function() {
        load(0);
    }, [
        startDateTime,
        endDateTime
    ]);
    var load = function(pageNo) {
        setLoading(true);
        var _filter = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filter), {
            pageNo: pageNo,
            startDateTime: startDateTime,
            endDateTime: endDateTime
        });
        setFilter(_filter);
        GetAnalyticsVendor({
            params: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _filter), {
                startDateTime: startDateTime,
                endDateTime: endDateTime
            }),
            onSuccess: function(res) {
                setData(res);
            },
            onError: function(message) {
                snackbar.snackbarHandle({
                    message: message,
                    value: true,
                    style: "error"
                });
            }
        }).then(function() {
            (0,common/* delayedCallback */.sf)(function() {
                setLoading(false);
            }, 500);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col ".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-grow overflow-auto",
                children: [
                    title && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.Typography, {
                                variant: "h3",
                                fontWeight: "medium",
                                size: "lg",
                                className: "mb-3 flex items-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "mr-1",
                                    children: "Vendor"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.LineSkeleton, {
                                    count: 1,
                                    size: "3xl",
                                    className: "w-32"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.Typography, {
                                    size: "2xl",
                                    fontWeight: "bold",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((build_default()), {
                                        duration: 200,
                                        value: data.pagination.totalElements,
                                        formatValue: function(value) {
                                            return (0,utils.formatNumberToCurrencyString)(Math.round(value));
                                        }
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.Table, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.TableBody, {
                            children: AnalyticsVendor_renderContent(loading, type, data)
                        })
                    })
                ]
            }),
            type === "detail" ? data.pagination.totalElements > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-center border-t border-neutrals-200 px-4 pb-4 pt-4 sm:justify-between sm:px-5 sm:pt-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "mr-1 hidden text-sm sm:block",
                        children: [
                            data.vendorList.length + data.pagination.pageSize * data.pagination.pageNo,
                            " dari",
                            " ",
                            data.pagination.totalElements,
                            " pembeli"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.Pagination, {
                        total: data.pagination.totalElements,
                        itemPerPage: filter.pageSize,
                        current: filter.pageNo + 1,
                        onSelect: function(value) {
                            load(value - 1);
                        }
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: data.pagination.totalElements > pageSize && !loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    role: "button",
                    className: "mt-4 flex items-center justify-end text-center text-sm text-primary no-underline hover:underline sm:mt-5",
                    onClick: onClickMore,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "mr-1",
                            children: "Lihat lebih banyak"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.Icon, {
                            name: "chevron-right"
                        })
                    ]
                })
            })
        ]
    });
};
var AnalyticsVendor_renderContent = function(loading, type, data) {
    if (loading) {
        return Array(3).fill(1).map(function(_, key) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(sachet.TableRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.TableColumn, {
                        paddingLeft: type === "detail" ? "lg" : "none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.LineSkeleton, {
                            count: 1,
                            size: "lg",
                            className: "w-32"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.TableColumn, {
                        paddingRight: type === "detail" ? "lg" : "none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.LineSkeleton, {
                            count: 1,
                            size: "lg",
                            className: "w-32"
                        })
                    })
                ]
            }, key);
        });
    }
    if (data.vendorList.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.TableRow, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.TableColumn, {
                paddingLeft: "none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.Typography, {
                    children: "Tidak ada data."
                })
            })
        });
    }
    return data.vendorList.map(function(item, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(sachet.TableRow, {
            border: !(index === data.vendorList.length - 1 && type === "detail"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.TableColumn, {
                    paddingLeft: type === "detail" ? "lg" : "none",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-normal",
                        children: item.name
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.TableColumn, {
                    paddingRight: type === "detail" ? "lg" : "none",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-right font-normal",
                        children: [
                            "Rp",
                            (0,utils.formatNumberToCurrencyString)(Math.round(item.totalCost))
                        ]
                    })
                })
            ]
        }, item.id);
    });
};

;// CONCATENATED MODULE: ./components/Analytics/AccountingDashboard.tsx








// import { GetInventoryInfo } from '~/data'

















dayjs_min_default().extend((isBetween_default()));
var AccountingDashboard = function() {
    var snackbar = (0,GlobalProvider/* useGlobal */.Og)().snackbar;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), ready = ref[0], setReady = ref[1];
    var ref1 = (0,react.useState)({
        startDateTime: dayjs_min_default()().format("YYYY-MM-DD[T]HH:mm:ss.SSSZ"),
        endDateTime: dayjs_min_default()().format("YYYY-MM-DD[T]HH:mm:ss.SSSZ"),
        withSalesData: true,
        withMoneyReceivedData: true,
        withDulyPaidData: true,
        withPaymentMethodData: true,
        invoicePayable: false
    }), filter = ref1[0], setFilter = ref1[1];
    var ref2 = (0,react.useState)({}), data = ref2[0], setData = ref2[1];
    var ref3 = (0,react.useState)({}), apData = ref3[0], setApData = ref3[1];
    var ref4 = (0,react.useState)(true), loading = ref4[0], setLoading = ref4[1];
    var ref5 = (0,react.useState)([
        {
            text: "Bulan ini",
            value: 0
        },
        {
            text: "Minggu ini",
            value: 1
        },
        {
            text: "Minggu lalu",
            value: 2
        },
        {
            text: "Bulan lalu",
            value: 3
        }
    ]), dateOptions = ref5[0];
    var ref6 = (0,react.useState)(0), selectedDateOptions = ref6[0], selectDateOptions = ref6[1];
    var ref7 = (0,react.useState)(), showDrawer = ref7[0], setShowDrawer = ref7[1];
    var ref8 = (0,react.useState)({
        timeFrame: "DAY",
        revenueReceived: []
    }), salesGraph = ref8[0], setSalesGraph = ref8[1];
    var ref9 = (0,react.useState)({
        timeFrame: "DAY",
        revenueReceived: []
    }), paymentsGraph = ref9[0], setPaymentsGraph = ref9[1];
    var ref10 = (0,react.useState)({
        timeFrame: "DAY",
        revenueReceived: []
    }), apSalesGraph = ref10[0], setApSalesGraph = ref10[1];
    var ref11 = (0,react.useState)({
        timeFrame: "DAY",
        revenueReceived: []
    }), apPaymentsGraph = ref11[0], setApPaymentsGraph = ref11[1];
    var ref12 = (0,react.useState)(false), loadingGraph = ref12[0], setLoadingGraph = ref12[1];
    var ref13 = (0,react.useState)(false), isAndroidWebview = ref13[0], setShowAndroidWebview = ref13[1];
    (0,react.useEffect)(function() {
        initialize();
        (0,common/* setOnBackPressed */.Pj)(common/* closeWebView */.WU);
        var isAndroidWebView = localStorage.getItem(constants/* STORAGE_WEBVIEW */.tc) === "true";
        setShowAndroidWebview(isAndroidWebView);
    }, []);
    var initialize = function() {
        var checkPersistentFilter = Number(sessionStorage.getItem(constants/* IS_PERSIST_FILTER */.Q6)) || null;
        if (checkPersistentFilter !== null) {
            selectDateOptions(function() {
                setReady(true);
                return checkPersistentFilter;
            });
            load(checkPersistentFilter);
            return;
        }
        setReady(true);
        load(0);
    };
    var getTimeFrame = function(timeFrame, selectedDateOptionValue) {
        if (timeFrame === "MONTH" && [
            1,
            2
        ].includes(selectedDateOptionValue)) {
            return "WEEK";
        }
        return timeFrame;
    };
    var load = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(value) {
            var ref, startDateTime, endDateTime, ref1, summary, apSummary, salesGraphData, paymentsGraphData, apSalesGraphData, apPaymentsGraphData;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        ref = getDateFilter(value), startDateTime = ref.startDateTime, endDateTime = ref.endDateTime;
                        setFilter(function(state) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                                startDateTime: startDateTime,
                                endDateTime: endDateTime
                            });
                        });
                        selectDateOptions(value);
                        return [
                            4,
                            (0,api/* multiPromiseResolver */.n)([
                                getAnalyticsSummary((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filter), {
                                    startDateTime: startDateTime,
                                    endDateTime: endDateTime
                                })),
                                getAnalyticsSummary((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filter), {
                                    startDateTime: startDateTime,
                                    endDateTime: endDateTime,
                                    invoicePayable: true
                                })),
                                getAnalyticsSalesGraph((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, {
                                    startDate: dayjs_min_default()(filter.startDateTime).format("YYYY-MM-DD"),
                                    endDate: dayjs_min_default()(filter.endDateTime).format("YYYY-MM-DD")
                                }), {
                                    startDate: dayjs_min_default()(startDateTime).format("YYYY-MM-DD"),
                                    endDate: dayjs_min_default()(endDateTime).format("YYYY-MM-DD"),
                                    timeFrame: getTimeFrame(salesGraph.timeFrame, value)
                                })),
                                getAnalyticsPaymentsGraph((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, {
                                    startDateTime: filter.startDateTime,
                                    endDateTime: filter.endDateTime
                                }), {
                                    startDateTime: startDateTime,
                                    endDateTime: endDateTime,
                                    timeFrame: getTimeFrame(paymentsGraph.timeFrame, value)
                                })),
                                getAnalyticsSalesGraph((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, {
                                    startDate: dayjs_min_default()(filter.startDateTime).format("YYYY-MM-DD"),
                                    endDate: dayjs_min_default()(filter.endDateTime).format("YYYY-MM-DD")
                                }), {
                                    startDate: dayjs_min_default()(startDateTime).format("YYYY-MM-DD"),
                                    endDate: dayjs_min_default()(endDateTime).format("YYYY-MM-DD"),
                                    timeFrame: getTimeFrame(salesGraph.timeFrame, value),
                                    invoicePayable: true
                                })),
                                getAnalyticsPaymentsGraph((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, {
                                    startDateTime: filter.startDateTime,
                                    endDateTime: filter.endDateTime
                                }), {
                                    startDateTime: startDateTime,
                                    endDateTime: endDateTime,
                                    timeFrame: getTimeFrame(paymentsGraph.timeFrame, value),
                                    invoicePayable: true
                                }))
                            ])
                        ];
                    case 1:
                        ref1 = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            6
                        ]), summary = ref1[0], apSummary = ref1[1], salesGraphData = ref1[2], paymentsGraphData = ref1[3], apSalesGraphData = ref1[4], apPaymentsGraphData = ref1[5];
                        (0,common/* delayedCallback */.sf)(function() {
                            setLoading(false);
                        }, 500);
                        if (!!summary.value && !!apSummary.value && !!salesGraphData.value && !!paymentsGraphData.value && !!apSalesGraphData.value && !!apPaymentsGraphData.value) {
                            setData(summary.value);
                            setApData(apSummary.value);
                            setSalesGraph(salesGraphData.value);
                            setPaymentsGraph(paymentsGraphData.value);
                            setApSalesGraph(apSalesGraphData.value);
                            setApPaymentsGraph(apPaymentsGraphData.value);
                        }
                        checkPageJumper();
                        return [
                            2
                        ];
                }
            });
        });
        return function load(value) {
            return _ref.apply(this, arguments);
        };
    }();
    var checkPageJumper = function() {
        var section = router.query.section;
        if (!section) {
            return;
        }
        var wrapper = document.getElementById("dashboard-wrapper");
        var title = document.getElementById(section);
        if (!wrapper || !title) {
            return;
        }
        wrapper.scrollTo({
            top: title.offsetTop
        });
        router.push("/");
    };
    var getAnalyticsSummary = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(filter) {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        data = {};
                        return [
                            4,
                            GetAnalyticsSummary({
                                params: filter,
                                onSuccess: function(res) {
                                    data = res;
                                },
                                onError: function(message) {
                                    snackbar.snackbarHandle({
                                        message: message,
                                        value: true,
                                        style: "error"
                                    });
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2,
                            data
                        ];
                }
            });
        });
        return function getAnalyticsSummary(filter) {
            return _ref.apply(this, arguments);
        };
    }();
    var getAnalyticsSalesGraph = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(filter) {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        data = (0,_object_spread/* default */.Z)({}, salesGraph);
                        return [
                            4,
                            GetAnalyticsSalesGraph({
                                params: filter,
                                onSuccess: function(res) {
                                    data = res;
                                },
                                onError: function(message) {
                                    snackbar.snackbarHandle({
                                        message: message,
                                        value: true,
                                        style: "error"
                                    });
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2,
                            data
                        ];
                }
            });
        });
        return function getAnalyticsSalesGraph(filter) {
            return _ref.apply(this, arguments);
        };
    }();
    var getAnalyticsPaymentsGraph = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(filter) {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        data = (0,_object_spread/* default */.Z)({}, paymentsGraph);
                        return [
                            4,
                            GetAnalyticsPaymentsGraph({
                                params: filter,
                                onSuccess: function(res) {
                                    data = res;
                                },
                                onError: function(message) {
                                    snackbar.snackbarHandle({
                                        message: message,
                                        value: true,
                                        style: "error"
                                    });
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2,
                            data
                        ];
                }
            });
        });
        return function getAnalyticsPaymentsGraph(filter) {
            return _ref.apply(this, arguments);
        };
    }();
    var onSelectTimeFrame = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(timeFrame) {
            var ref, salesGraphData, paymentsGraphData, apSalesGraphData, apPaymentsGraphData;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoadingGraph(true);
                        return [
                            4,
                            (0,api/* multiPromiseResolver */.n)([
                                getAnalyticsSalesGraph({
                                    startDate: dayjs_min_default()(filter.startDateTime).format("YYYY-MM-DD"),
                                    endDate: dayjs_min_default()(filter.endDateTime).format("YYYY-MM-DD"),
                                    timeFrame: timeFrame
                                }),
                                getAnalyticsPaymentsGraph({
                                    startDateTime: filter.startDateTime,
                                    endDateTime: filter.endDateTime,
                                    timeFrame: timeFrame
                                }),
                                getAnalyticsSalesGraph({
                                    startDate: dayjs_min_default()(filter.startDateTime).format("YYYY-MM-DD"),
                                    endDate: dayjs_min_default()(filter.endDateTime).format("YYYY-MM-DD"),
                                    timeFrame: timeFrame,
                                    invoicePayable: true
                                }),
                                getAnalyticsPaymentsGraph({
                                    startDateTime: filter.startDateTime,
                                    endDateTime: filter.endDateTime,
                                    timeFrame: timeFrame,
                                    invoicePayable: true
                                })
                            ])
                        ];
                    case 1:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            4
                        ]), salesGraphData = ref[0], paymentsGraphData = ref[1], apSalesGraphData = ref[2], apPaymentsGraphData = ref[3];
                        (0,common/* delayedCallback */.sf)(function() {
                            setLoadingGraph(false);
                        });
                        if (!!salesGraphData.value && !!paymentsGraphData.value && !!apSalesGraphData.value && !!apPaymentsGraphData.value) {
                            setSalesGraph(salesGraphData.value);
                            setPaymentsGraph(paymentsGraphData.value);
                            setApSalesGraph(apSalesGraphData.value);
                            setApPaymentsGraph(apPaymentsGraphData.value);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onSelectTimeFrame(timeFrame) {
            return _ref.apply(this, arguments);
        };
    }();
    var onSelectDate = function(value) {
        sessionStorage.setItem(constants/* IS_PERSIST_FILTER */.Q6, String(value));
        load(value);
    };
    // const percentChanges = (): AnalyticsSummaryI => {
    //     return {
    //         totalSales: getPercentageDifference(data.totalSales || 0, compareData.totalSales || 0),
    //         totalMoneyReceived: getPercentageDifference(data.totalMoneyReceived || 0, compareData.totalMoneyReceived || 0),
    //         totalPaidSales: getPercentageDifference(data.totalPaidSales || 0, compareData.totalPaidSales || 0),
    //         totalUnpaidSales: getPercentageDifference(data.totalUnpaidSales || 0, compareData.totalUnpaidSales || 0)
    //     }
    // }
    var profit = (data.totalSales || 0) - (apData.totalSales || 0);
    var isProfit = profit >= 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default */.Z, {
                title: "Dashboard"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-full w-full",
                "data-testid": "accounting-dashboard",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex h-full w-full flex-col",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative flex flex-grow flex-col overflow-hidden",
                        children: [
                            isAndroidWebview && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center p-4 font-bold text-white",
                                style: {
                                    background: "#0091FF"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.Icon, {
                                        name: "x",
                                        size: "xl",
                                        onClick: function() {
                                            return (0,common/* closeWebView */.WU)();
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "ml-3 text-lg",
                                        children: "Statistik Invoice"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex-grow overflow-auto p-4 sm:p-5",
                                id: "dashboard-wrapper",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "hidden items-center sm:flex ".concat(!isProfit ? "text-red-400" : "text-green-400")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex w-full max-w-7xl items-center",
                                        "data-testid": "homepage-header",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: "text-xl font-bold text-neutrals-800 sm:text-2xl",
                                                id: "pemasukan",
                                                children: "Pemasukan"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.Spacer, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex items-center",
                                                "data-testid": "filter",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.Select, {
                                                    options: dateOptions,
                                                    width: 180,
                                                    value: selectedDateOptions,
                                                    onSelect: onSelectDate
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "my-4 flex w-full max-w-7xl flex-col sm:my-5 xl:flex-row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "hidden w-full max-w-full flex-shrink-0 grid-cols-1 gap-4 sm:grid sm:grid-cols-2 sm:gap-5 xl:w-[300px] xl:grid-cols-1",
                                                children: [
                                                    Summary(loading, "Penjualan", "Penjualan adalah total nilai dari\nsemua invoice yang telah dibuat\ndalam periode terpilih.", data.totalSales),
                                                    Summary(loading, "Terbayar", "Terbayar adalah total invoice yang\ntelah di bayar berdasarkan tanggal\ninvoice dibuat dalam periode terpilih.", data.totalPaidSales),
                                                    Summary(loading, "Belum Dibayar", "Belum Dibayar adalah total invoice yang\nbelum di bayar berdasarkan taggal\ninvoice dibuat dalam periode terpilih.", data.totalUnpaidSales),
                                                    Summary(loading, "Uang Diterima", "Uang Diterima adalah pembayaran\ndari invoice dalam periode terpilih\nyang di hitung berdasarkan tanggal pembayaran.", data.totalMoneyReceived)
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "block sm:hidden",
                                                children: SummaryMobile(loading, [
                                                    {
                                                        title: "Penjualan",
                                                        tooltip: "Penjualan adalah total nilai dari\nsemua invoice yang telah dibuat\ndalam periode terpilih.",
                                                        value: data.totalSales || 0
                                                    },
                                                    {
                                                        title: "Terbayar",
                                                        tooltip: "Terbayar adalah total invoice yang\ntelah di bayar berdasarkan tanggal\ninvoice dibuat dalam periode terpilih.",
                                                        value: data.totalPaidSales || 0
                                                    },
                                                    {
                                                        title: "Belum Dibayar",
                                                        tooltip: "Belum Dibayar adalah total invoice yang\nbelum di bayar berdasarkan taggal\ninvoice dibuat dalam periode terpilih.",
                                                        value: data.totalUnpaidSales || 0
                                                    },
                                                    {
                                                        title: "Uang Diterima",
                                                        tooltip: "Uang Diterima adalah pembayaran\ndari invoice dalam periode terpilih\nyang di hitung berdasarkan tanggal pembayaran.",
                                                        value: data.totalMoneyReceived || 0
                                                    }
                                                ])
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "h-4 w-0 flex-shrink-0 xl:h-0 xl:w-5"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex w-full flex-shrink items-stretch",
                                                children: renderLineChart([
                                                    salesGraph.revenueReceived,
                                                    paymentsGraph.revenueReceived
                                                ], salesGraph.timeFrame, "Penjualan & Uang Diterima", loading || !ready || loadingGraph, selectedDateOptions, [
                                                    "Penjualan",
                                                    "Uang Diterima"
                                                ], onSelectTimeFrame)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "block",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: "mb-5 pt-3 text-xl font-bold text-neutrals-800 sm:text-2xl",
                                                id: "pengeluaran",
                                                children: "Pengeluaran"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "my-4 flex w-full max-w-7xl flex-col sm:my-5 xl:flex-row",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "hidden w-full max-w-full flex-shrink-0 grid-cols-1 gap-4 sm:grid sm:grid-cols-2 sm:gap-5 xl:w-[300px] xl:grid-cols-1",
                                                        children: [
                                                            Summary(loading, "Pengeluaran", "Pengeluaran adalah total nilai dari\nsemua invoice yang telah dibuat\ndalam periode terpilih.", apData.totalSales),
                                                            Summary(loading, "Terbayar", "Terbayar adalah total invoice yang\ntelah di bayar berdasarkan tanggal\ninvoice dibuat dalam periode terpilih.", apData.totalPaidSales),
                                                            Summary(loading, "Belum Dibayar", "Belum Dibayar adalah total invoice yang\nbelum di bayar berdasarkan taggal\ninvoice dibuat dalam periode terpilih.", apData.totalUnpaidSales),
                                                            Summary(loading, "Uang Dikirim", "Uang Dikirim adalah pembayaran\ndari invoice dalam periode terpilih\nyang di hitung berdasarkan tanggal pembayaran.", apData.totalMoneyReceived)
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "block sm:hidden",
                                                        children: SummaryMobile(loading, [
                                                            {
                                                                title: "Pengeluaran",
                                                                tooltip: "Penjualan adalah total nilai dari\nsemua invoice yang telah dibuat\ndalam periode terpilih.",
                                                                value: data.totalSales || 0
                                                            },
                                                            {
                                                                title: "Terbayar",
                                                                tooltip: "Terbayar adalah total invoice yang\ntelah di bayar berdasarkan tanggal\ninvoice dibuat dalam periode terpilih.",
                                                                value: data.totalPaidSales || 0
                                                            },
                                                            {
                                                                title: "Belum Dibayar",
                                                                tooltip: "Belum Dibayar adalah total invoice yang\nbelum di bayar berdasarkan taggal\ninvoice dibuat dalam periode terpilih.",
                                                                value: data.totalUnpaidSales || 0
                                                            },
                                                            {
                                                                title: "Uang Dikirim",
                                                                tooltip: "Uang Diterima adalah pembayaran\ndari invoice dalam periode terpilih\nyang di hitung berdasarkan tanggal pembayaran.",
                                                                value: data.totalMoneyReceived || 0
                                                            }
                                                        ])
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "h-4 w-0 flex-shrink-0 xl:h-0 xl:w-5"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex w-full flex-shrink items-stretch",
                                                        children: renderLineChart([
                                                            apSalesGraph.revenueReceived,
                                                            apPaymentsGraph.revenueReceived
                                                        ], salesGraph.timeFrame, "Pengeluaran & Uang Dikirim", loading || !ready || loadingGraph, selectedDateOptions, [
                                                            "Pengeluaran",
                                                            "Uang Dikirim"
                                                        ], onSelectTimeFrame)
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "mb-5 pt-3 text-2xl font-bold text-neutrals-800",
                                        children: "Informasi Lain"
                                    }),
                                    ready && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mb-4 grid w-full max-w-7xl grid-cols-1 gap-4 sm:mb-5 sm:gap-5 md:grid-cols-2",
                                        children: [
                                            renderPieChart(getPayableCategoryCount(apData.invoicePayableCategoryCount, getTotalPayableInvoice(apData.invoicePayableCategoryCount)), getTotalPayableInvoice(apData.invoicePayableCategoryCount), "Kategori Pengeluaran", "Komposisi kategori pengeluaran berdasarkan nilai\nyang ada pada invoice yang tercatat.", loading || !ready),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.CardWrapper, {
                                                fullWidth: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnalyticsProduct, {
                                                    pageSize: 3,
                                                    startDateTime: filter.startDateTime,
                                                    endDateTime: filter.endDateTime,
                                                    onClickMore: function() {
                                                        return setShowDrawer("product");
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.CardWrapper, {
                                                fullWidth: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnalyticsVendor, {
                                                    pageSize: 3,
                                                    startDateTime: filter.startDateTime,
                                                    endDateTime: filter.endDateTime,
                                                    onClickMore: function() {
                                                        return setShowDrawer("vendor");
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.CardWrapper, {
                                                fullWidth: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnalyticsCustomer, {
                                                    pageSize: 3,
                                                    startDateTime: filter.startDateTime,
                                                    endDateTime: filter.endDateTime,
                                                    onClickMore: function() {
                                                        return setShowDrawer("customer");
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnalyticsDrawer, {
                                show: !!showDrawer,
                                title: showDrawer === "customer" ? "Pembeli" : showDrawer === "vendor" ? "Vendor" : "Produk Terjual",
                                onDrawerClose: function() {
                                    return setShowDrawer(undefined);
                                },
                                children: showDrawer === "product" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AnalyticsProduct, {
                                    type: "detail",
                                    startDateTime: filter.startDateTime,
                                    endDateTime: filter.endDateTime,
                                    title: false,
                                    className: "flex-grow"
                                }) : showDrawer === "vendor" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AnalyticsVendor, {
                                    type: "detail",
                                    startDateTime: filter.startDateTime,
                                    endDateTime: filter.endDateTime,
                                    title: false,
                                    className: "flex-grow"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AnalyticsCustomer, {
                                    type: "detail",
                                    startDateTime: filter.startDateTime,
                                    endDateTime: filter.endDateTime,
                                    title: false,
                                    className: "flex-grow"
                                })
                            }, showDrawer)
                        ]
                    })
                })
            })
        ]
    });
};
var Summary = function(loading, title, tooltip) {
    var value = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(sachet.CardWrapper, {
        fullWidth: true,
        paddingSize: "sm",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(sachet.Typography, {
                variant: "h3",
                fontWeight: "medium",
                size: "lg",
                className: "mb-3 flex items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "mr-1",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.Tooltip, {
                        position: "bottom",
                        content: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "font-normal",
                            children: tooltip
                        }),
                        variant: "lighter",
                        trigger: "click",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "flex h-6 w-6 items-center justify-center rounded-full hover:bg-neutrals-200",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.Icon, {
                                name: "question-mark-outline",
                                width: 16,
                                color: sachet.COLORS.SEMANTIC.BLUE[500]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.LineSkeleton, {
                    count: 1,
                    size: "3xl",
                    className: "w-32"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((build_default()), {
                    duration: 200,
                    value: value,
                    formatValue: function(value) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(sachet.Typography, {
                            size: "2xl",
                            fontWeight: "bold",
                            children: [
                                "Rp",
                                (0,utils.formatNumberToCurrencyString)(Math.floor(value))
                            ]
                        });
                    }
                })
            })
        ]
    });
};
var SummaryMobile = function(loading, data) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.CardWrapper, {
        fullWidth: true,
        paddingSize: "sm",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "grid grid-cols-1 gap-4",
            children: data.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat(index === data.length - 1 ? "" : "border-b border-neutrals-200 pb-4"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(sachet.Typography, {
                            variant: "h3",
                            size: "base",
                            className: "mb-1 flex items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "mr-1 text-neutrals-500",
                                    children: item.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.Tooltip, {
                                    position: "bottom",
                                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-normal",
                                        children: item.tooltip
                                    }),
                                    variant: "lighter",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "flex h-6 w-6 items-center justify-center rounded-full hover:bg-neutrals-200",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.Icon, {
                                            name: "question-mark-outline",
                                            width: 16,
                                            color: sachet.COLORS.SEMANTIC.BLUE[500]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.LineSkeleton, {
                                count: 1,
                                size: "3xl",
                                className: "w-32"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((build_default()), {
                                duration: 200,
                                value: item.value || 0,
                                formatValue: function(value) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(sachet.Typography, {
                                        size: "xl",
                                        fontWeight: "bold",
                                        children: [
                                            "Rp",
                                            (0,utils.formatNumberToCurrencyString)(Math.floor(value))
                                        ]
                                    });
                                }
                            })
                        })
                    ]
                }, index);
            })
        })
    });
};
/**
 * Get date filter based on value
 * @param value
 */ var getDateFilter = function(value) {
    var today = dayjs_min_default()();
    var currentMonthStart = today.startOf("month");
    var currentWeekStart = today.startOf("week");
    var lastMonthStart = today.startOf("month").subtract(1, "day").startOf("month");
    var lastWeekStart = today.startOf("week").subtract(1, "day").startOf("week");
    var differenceCurrentMonth = today.diff(currentMonthStart, "day");
    var differenceCurrentWeek = today.diff(currentWeekStart, "day");
    switch(value){
        case 0:
            return {
                startDateTime: today.startOf("month").format("YYYY-MM-DD[T]HH:mm:ss.SSSZ"),
                endDateTime: today.endOf("month").format("YYYY-MM-DD[T]HH:mm:ss.SSSZ"),
                compareStartDateTime: lastMonthStart.format("YYYY-MM-DD[T]HH:mm:ss.SSSZ"),
                compareEndDateTime: lastMonthStart.add(differenceCurrentMonth, "day").format("YYYY-MM-DD[T]HH:mm:ss.SSSZ")
            };
        case 1:
            return {
                startDateTime: today.startOf("week").format("YYYY-MM-DD[T]HH:mm:ss.SSSZ"),
                endDateTime: today.endOf("week").format("YYYY-MM-DD[T]HH:mm:ss.SSSZ"),
                compareStartDateTime: lastWeekStart.format("YYYY-MM-DD[T]HH:mm:ss.SSSZ"),
                compareEndDateTime: lastWeekStart.add(differenceCurrentWeek, "day").format("YYYY-MM-DD[T]HH:mm:ss.SSSZ")
            };
        case 2:
            var previousWeekStart = lastWeekStart.subtract(1, "day").startOf("week");
            return {
                startDateTime: lastWeekStart.format("YYYY-MM-DD[T]HH:mm:ss.SSSZ"),
                endDateTime: lastWeekStart.endOf("week").format("YYYY-MM-DD[T]HH:mm:ss.SSSZ"),
                compareStartDateTime: previousWeekStart.format("YYYY-MM-DD[T]HH:mm:ss.SSSZ"),
                compareEndDateTime: previousWeekStart.add(differenceCurrentWeek, "day").format("YYYY-MM-DD[T]HH:mm:ss.SSSZ")
            };
        case 3:
            var previousMonthStart = lastMonthStart.subtract(1, "day").startOf("month");
            return {
                startDateTime: lastMonthStart.format("YYYY-MM-DD[T]HH:mm:ss.SSSZ"),
                endDateTime: lastMonthStart.endOf("month").format("YYYY-MM-DD[T]HH:mm:ss.SSSZ"),
                compareStartDateTime: previousMonthStart.format("YYYY-MM-DD[T]HH:mm:ss.SSSZ"),
                compareEndDateTime: previousMonthStart.add(differenceCurrentMonth, "day").format("YYYY-MM-DD[T]HH:mm:ss.SSSZ")
            };
    }
    return {
        startDateTime: today.startOf("month").format("YYYY-MM-DD[T]HH:mm:ss.SSSZ"),
        endDateTime: today.endOf("month").format("YYYY-MM-DD[T]HH:mm:ss.SSSZ"),
        compareStartDateTime: lastMonthStart.format("YYYY-MM-DD[T]HH:mm:ss.SSSZ"),
        compareEndDateTime: lastMonthStart.add(differenceCurrentMonth, "day").format("YYYY-MM-DD[T]HH:mm:ss.SSSZ")
    };
};
var PIE_COLORS = [
    "#4C7ACD",
    "#023075",
    "#FFDE68",
    "#E4A600",
    "#F78A1D",
    "#99C24D",
    "#A68CC1",
    "#47B1BC",
    "#F2675C",
    "#A1A1A1"
];
/**
 * Get on time payment data
 * @param {number} totalOnTime - Total on time payment
 * @param {number} totalLate - Total late payment
 * @param {number} total - Total payment
 * @returns {PieChartItemsI[]} - Pie chart data items
 */ var getOnTimePaymentData = function(totalOnTime, totalLate, total) {
    var items = [
        {
            text: "Tepat Waktu",
            value: totalOnTime,
            percent: getPercentageBetweenTwo(totalOnTime, total),
            color: "#47B1BC"
        },
        {
            text: "Terlambat",
            value: totalLate,
            percent: getPercentageBetweenTwo(totalLate, total),
            color: "#F2675C"
        }
    ];
    return items;
};
/**
 * Get payment method data
 * @param {AnalyticsInvoicePaymentMethodT} data - Payment method data
 * @param {number} total - Total payment
 * @returns {PieChartItemsI[]} - Pie chart data items
 */ var getPaymentMethodData = function(data, total) {
    var items = [];
    var index = 0;
    for(var item in data){
        items.push({
            color: PIE_COLORS[index],
            text: item,
            value: data[item],
            percent: getPercentageBetweenTwo(data[item], total)
        });
        index++;
    }
    return items;
};
var getTotalPayableInvoice = function(data) {
    if (!data) {
        return 0;
    }
    return Object.values(data).reduce(function(a, b) {
        return a + b;
    }, 0);
};
/**
 * Get payable invoice category data
 * @param {AnalyticsSummaryI['invoicePayableCategoryCount']} data - payable invoice category data
 * @param {number} total - Total payment
 * @returns {PieChartItemsI[]} - Pie chart data items
 */ var getPayableCategoryCount = function(data, total) {
    var items = [];
    var index = 0;
    for(var item in data){
        items.push({
            color: PIE_COLORS[index],
            text: invoice/* InvoiceExpenseTypesMap */.g[item],
            value: data[item],
            percent: (0,common/* getPercentageBetweenTwo */.Mj)(data[item], total)
        });
        index++;
    }
    return items;
};
/**
 * Render pie chart
 * @param {PieChartItemsI[]} data - Pie chart data items
 * @param {number} count - Total count of data
 * @param {string} title - Title of the chart
 * @param {string} tooltip - Tooltip of the chart title
 * @param {boolean} loading - Loading state
 * @returns {JSX.Element} - Rendered pie chart
 */ var renderPieChart = function(data, count, title, tooltip, loading) {
    var renderContent = function() {
        if (loading) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.PieChartLoader, {
                width: 220,
                height: 220
            });
        }
        if (count === 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.Typography, {
                variant: "p",
                className: "mt-4 w-full sm:mt-5",
                children: "Tidak ada data."
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex w-full flex-col items-center xl:flex-row xl:items-start",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.PieChart, {
                    items: data
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.Table, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.TableBody, {
                        children: data.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(sachet.TableRow, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.TableColumn, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "mr-4 block h-4 w-4 rounded",
                                                    style: {
                                                        background: item.color
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "font-normal",
                                                    children: item.text
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.TableColumn, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "font-normal",
                                            children: (0,utils.formatNumberToCurrencyString)(item.value)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.TableColumn, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-right font-normal",
                                            children: [
                                                Number(item.percent.toFixed(2)),
                                                "%"
                                            ]
                                        })
                                    })
                                ]
                            }, item.text);
                        })
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(sachet.CardWrapper, {
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                className: "flex items-center text-lg text-neutrals-900",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "mr-1 font-medium",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.Tooltip, {
                        position: "top",
                        content: tooltip,
                        variant: "lighter",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "flex h-6 w-6 items-center justify-center rounded-full hover:bg-neutrals-200",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.Icon, {
                                name: "question-mark-outline",
                                width: 16,
                                color: sachet.COLORS.SEMANTIC.BLUE[500]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col items-center",
                children: renderContent()
            })
        ]
    });
};
var renderLineChart = function(data, timeFrame, title, loading, selectedDateOptions, labels, onSelectTimeFrame) {
    var ref = (0,react.useState)(0), deviceWidth = ref[0], setDeviceWidth = ref[1];
    var filteredDataSales = (0,react.useMemo)(function() {
        if (data.length < 2) {
            return data[0];
        }
        var dataSales = data[0];
        var dataPayments = data[1];
        if (dataSales.length === 0 || dataPayments.length === 0) {
            return data[0];
        }
        var filteredData = dataSales.filter(function(item) {
            // return only data that matches startDate and endDate in data payments
            return dataPayments.some(function(payment) {
                return item.startDate === payment.startDate && item.endDate === payment.endDate;
            });
        });
        return filteredData;
    }, [
        data
    ]);
    (0,sachet.useGetDeviceWidth)(setDeviceWidth);
    var isMobile = deviceWidth <= sachet.responsiveBreakpointMap.sm;
    var getPaymentsRevenueByDate = function(startDate, endDate) {
        var ref;
        return ((ref = data[1].find(function(item) {
            return item.startDate === startDate && item.endDate === endDate;
        })) === null || ref === void 0 ? void 0 : ref.totalRevenue) || 0;
    };
    var chartData = (0,react.useMemo)(function() {
        return {
            labels: labels,
            sets: filteredDataSales.map(function(item) {
                return (0,_object_spread/* default */.Z)({
                    values: [
                        item.totalRevenue,
                        getPaymentsRevenueByDate(item.startDate, item.endDate)
                    ]
                }, getLineChartItem(timeFrame, item.startDate, item.endDate, item.totalRevenue));
            })
        };
    }, [
        filteredDataSales
    ]);
    var timeFrameOptions = (0,react.useMemo)(function() {
        var options = [
            {
                text: "Hari",
                value: "DAY"
            },
            {
                text: "Minggu",
                value: "WEEK"
            }
        ];
        if ([
            0,
            3
        ].includes(selectedDateOptions)) {
            options.push({
                text: "Bulan",
                value: "MONTH"
            });
        }
        return options;
    }, [
        selectedDateOptions
    ]);
    var renderContent = function() {
        if (loading) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LineChartLoader, {});
        }
        if (chartData.sets.length === 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.Typography, {
                variant: "p",
                className: "mt-4 w-full sm:mt-5",
                children: "Tidak ada data."
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex w-full min-w-[650px] flex-col items-center xl:flex-row xl:items-start",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LineChart, {
                data: chartData,
                minUpperBound: 900,
                minHeight: isMobile ? 300 : undefined,
                formatYTicks: function(value) {
                    return "Rp".concat((0,utils.formatNumberToCurrencyString)(Math.floor(value)));
                }
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(sachet.CardWrapper, {
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                className: "mb-5 flex items-center text-lg text-neutrals-900 sm:mb-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "mr-1 sm:font-medium",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.Spacer, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sachet.Select, {
                        width: 120,
                        placeholder: "Pilih periode",
                        options: timeFrameOptions,
                        value: timeFrame,
                        onSelect: function(value) {
                            return onSelectTimeFrame(value);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "overflow-auto",
                children: renderContent()
            })
        ]
    });
};
var getLineChartItem = function(timeFrame, startDate, endDate, totalRevenue) {
    var start = dayjs_min_default()(startDate);
    var end = dayjs_min_default()(endDate);
    var xTickName;
    switch(timeFrame){
        case "DAY":
            xTickName = "".concat(start.format("DD MMM"), " ");
            return {
                xTickName: xTickName,
                tooltip: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-64 rounded text-sm",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "border-b border-neutral-200 bg-neutrals-100 p-4",
                            children: xTickName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "p-4 font-semibold",
                            children: totalRevenue
                        })
                    ]
                })
            };
        case "WEEK":
            xTickName = "".concat(start.format("DD MMM"), " - ").concat(end.subtract(1, "day").format("DD MMM"));
            return {
                xTickName: xTickName,
                tooltip: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-64 rounded text-sm",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "border-b border-neutral-200 bg-neutrals-100 p-4",
                            children: xTickName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "p-4 font-semibold",
                            children: totalRevenue
                        })
                    ]
                })
            };
        case "MONTH":
            xTickName = "".concat(start.format("MMM YYYY"));
            return {
                xTickName: xTickName,
                tooltip: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-64 rounded text-sm",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "border-b border-neutral-200 bg-neutrals-100 p-4",
                            children: xTickName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "p-4 font-semibold",
                            children: totalRevenue
                        })
                    ]
                })
            };
    }
};

;// CONCATENATED MODULE: ./pages/index.tsx



var Homepage = function() {
    var store = (0,GlobalProvider/* useGlobal */.Og)().store;
    if (!store) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountingDashboard, {});
};
/* harmony default export */ var pages = (Homepage);


/***/ }),

/***/ 5043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ InvoiceModes; },
/* harmony export */   "g": function() { return /* binding */ InvoiceExpenseTypesMap; }
/* harmony export */ });
var InvoiceModes;
(function(InvoiceModes) {
    InvoiceModes["create"] = "CREATE";
    InvoiceModes["edit"] = "EDIT";
})(InvoiceModes || (InvoiceModes = {}));
var InvoiceExpenseTypesMap = {
    PURCHASE: "Pembelian",
    "AIR ATAU PDAM": "Air/PDAM",
    "ALAT TULIS KANTOR": "Alat Tulis Kantor",
    "GAJI ATAU UPAH": "Gaji/Upah",
    INTERNET: "Internet",
    LISTRIK: "Listrik",
    "PULSA ATAU PAKET DATA": "Pulsa/Paket Data",
    SEWA: "Sewa",
    TRANSPORTASI: "Transportasi",
    LAINNYA: "Lainnya"
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6337,9774,2888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);